import { useState, useEffect } from 'react';
import './PasswordGate.css';

const PASSWORD = 'aelieve2025';
const STORAGE_KEY = 'dashboard_authenticated';

interface PasswordGateProps {
  children: React.ReactNode;
}

export function PasswordGate({ children }: PasswordGateProps) {
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if already authenticated
    const isAuth = sessionStorage.getItem(STORAGE_KEY);
    if (isAuth === 'true') {
      setAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  if (loading) {
    return null;
  }

  if (authenticated) {
    return <>{children}</>;
  }

  return (
    <div className="password-gate">
      <div className="password-card">
        <div className="password-header">
          <h1>Investment Properties</h1>
          <p>Enter password to access the dashboard</p>
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoFocus
            className="password-input"
          />
          {error && <div className="password-error">{error}</div>}
          <button type="submit" className="password-submit">
            Enter
          </button>
        </form>
      </div>
    </div>
  );
}
